import { TERTIARY_NAVIGATION_QUERY_PARAMS } from 'context/FirmBaseLayoutContext/tertiaryNavigation.constants';
import { FIRM_DOCUMENTS_QUERY_PARAMS } from 'pages/Documents/FirmDocuments/FirmDocuments.constants';

const FIRM_DOCUMENTS_WORKSPACE_SEARCH_PARAMS = [
  TERTIARY_NAVIGATION_QUERY_PARAMS.tab,
  ...Object.values(FIRM_DOCUMENTS_QUERY_PARAMS),
];

export const stripFirmDocumentsWorkspaceSearchParams = (search: string): string => {
  const params = new URLSearchParams(search);

  FIRM_DOCUMENTS_WORKSPACE_SEARCH_PARAMS.forEach(param => params.delete(param));

  return params.size > 0 ? `?${params.toString()}` : '';
};
